import type {
  IEmailOtpSendDTO,
  IEmailOtpSendResponse,
  IEmailOtpVerifyDTO,
  IEmailOtpVerifyResponse,
} from './types'
import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/shared/api'

/**
 * Email OTP Api
 */

// === Email OTP Send ===

// Email OTP Send Request (Send email OTP)
export function emailOtpSendRequest(data: IEmailOtpSendDTO) {
  return apiClient.post<IEmailOtpSendResponse>('/email-otp/send/', data)
}

// Email OTP Send Mutation
export function useEmailOtpSendMutation() {
  return useMutation({
    mutationFn: emailOtpSendRequest,
  })
}

// === Email OTP Verify ===

// Email OTP Verify Request (Verify email OTP)
export function emailOtpVerifyRequest(data: IEmailOtpVerifyDTO) {
  return apiClient.post<IEmailOtpVerifyResponse>('/email-otp/verify/', data)
}

// Email OTP Verify Mutation
export function useEmailOtpVerifyMutation() {
  return useMutation({
    mutationFn: emailOtpVerifyRequest,
  })
}
